exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.manage-el-dialog {\r\n  width: 600px !important;\n}\r\n/* @media screen and (min-width: 100px) {\r\n  .manage-el-dialog {\r\n    width: 70% !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .manage-el-dialog {\r\n    width: 70% !important;\r\n  }\r\n}\r\n@media screen and (min-width: 992px) {\r\n  .manage-el-dialog {\r\n    width: 50% !important;\r\n  }\r\n}\r\n@media screen and (min-width: 1200px) {\r\n  .manage-el-dialog {\r\n    width: 30% !important;\r\n  }\r\n} */\r\n", ""]);

// exports
